import { useRouter } from "next/router";
import { useUser } from "../../../hooks/useUser";
import { ProfileActions } from "./ProfileActions"
import { ProfileDescription } from "./ProfileDescription";
import { GeneralProfile } from "./ProfileGeneral"
import { ProfileSite } from "./ProfileSite";
import { StatisticsProfile } from "./ProfileStatistics"

export const ProfileSidebar = () => {
    const router = useRouter();
    const { isLoading, data } = useUser(router.query.username as string);

    return (
        <div className="lg:max-w-[370px] w-full h-full  lg:sticky lg:top-[96px]">
            <GeneralProfile />
            {data?.description &&
                <ProfileDescription />
            }
            {data?.site &&
                <ProfileSite />
            }
            <StatisticsProfile />
            <ProfileActions />
        </div>
    )
}